// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__xaz0V","subTitleBold":"BoxSubTitle_subTitleBold__8OQ3j"};